import { unusableGpsReasonOf, type Finding } from './finding'
import type {
  DataQualityMetrics,
  StageExecutionInfo,
} from '../processors/pipeline/ProcessingPipeline'

export interface UnusableTelemetryFacts {
  stages: StageExecutionInfo[]
  dataQuality: DataQualityMetrics
}

export class UnusableTelemetryError extends Error {
  override readonly name = 'UnusableTelemetryError'

  constructor(
    readonly findings: readonly Finding[],
    readonly facts?: UnusableTelemetryFacts
  ) {
    super(unusableGpsReasonOf(findings) ?? 'The telemetry is unusable')
  }
}
